// import React from 'react';
// import  { connect } from 'react-redux';
// import { history } from '../../History';
// import LoginComponent from './LoginComponent';
// import Preloader from '../Preloader/Preloader';
// import LoginWrapper from './Login.style';
// import { startLogin, loginRequest, loginFailure } from '../../redux/actions/Auth/AuthActions';

// class Login extends React.Component {

//   constructor() {
//     super();

//     this.handleRequest = this.handleRequest.bind(this);
//     this.handleSuccess = this.handleSuccess.bind(this);
//     this.handleFailure = this.handleFailure.bind(this);
//     this.handleLoginClick = this.handleLoginClick.bind(this);
//   }

//   handleRequest() {
//     this.props.loginRequest();
//   }

//   handleSuccess(response) {
//     this.props.startLogin(response.tokenId);
//   }

//   handleFailure(response) {
//     this.props.loginFailure();
//     history.push('/');
//   }

//   handleLoginClick() {
//     document.querySelector('.hidden-login-btn').click();
//   }

//   render() {
//     if(this.props.APPREDUCER.showPreloader === true) {
//       return(
//         <Preloader />
//       );
//     }
//     else {
//       return(
//         <LoginWrapper>
//           <LoginComponent
//             handleRequest={this.handleRequest}
//             handleSuccess={this.handleSuccess}
//             handleFailure={this.handleFailure}
//             handleLoginClick={this.handleLoginClick}
//           />
//         </LoginWrapper>
//       );
//     }
//   }
// }

// function mapStateToProps(state) {
//   return state;
// }

// const mapDispatchToProps = {
//   startLogin,
//   loginRequest,
//   loginFailure
// };

// export default connect(mapStateToProps, mapDispatchToProps)(Login);
import React from "react";
import { connect } from "react-redux";
import { history } from "../../History";
import LoginComponent from "./LoginComponent";
import LoginWrapper from "./Login.style";
import { startLogin, loginFailure } from "../../redux/actions/Auth/AuthActions";

class Login extends React.Component {
  componentDidMount() {
    // Redirect the user if he is already logged in
    if (this.props.IS_AUTH) {
      history.push("/home");
    }
    localStorage.clear();
    sessionStorage.clear();
  }

  constructor() {
    super();
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleFailure = this.handleFailure.bind(this);
  }

  // Register login success in the application reducer
  handleSuccess(response) {
    // this.props.startLogin(response.tokenId);

    this.props.startLogin();
  }

  // Register login failure on the application reducer
  handleFailure(response) {
    this.props.loginFailure();
    history.push("/");
  }

  render() {
    return (
      <LoginWrapper>
        <LoginComponent
          handleSuccess={this.handleSuccess}
          handleFailure={this.handleFailure}
          is_auth_attempt={this.props.IS_AUTH_ATTEMPT}
        />
      </LoginWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    IS_AUTH: state.LOGINREDUCER.ISAUTH,
    IS_AUTH_ATTEMPT: state.LOGINREDUCER.ISAUTHATTEMPT,
  };
}

const mapDispatchToProps = {
  startLogin,
  loginFailure,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js